import { render } from "./App.vue?vue&type=template&id=48508514"
const script = {}

import exportComponent from "F:\\web\\zlhranhou-cz-comt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__